<template>
  <div v-if="isReady">

    <template v-if="items.length > 0">
        <div class="max-w-xl mx-auto">
          <div class="text-3xl">Valgresultat</div>
          <div class="text-xl" v-if="electionPeriod">
            Vi kan med glede informere om at apoteket har blitt valgt som praksisapotek i valgperioden <span class="font-bold">{{ electionPeriod.name }}</span>. Dere har fått følgende studenter:
          </div>
        </div>
        <panel class="mt-8">
          <data-table
          :headers="headers"
          :items="items">
        </data-table>
      </panel>
    </template>

    <template v-else>
      <div class="flex h-full items-center justify-center">
        <div class="md:w-4/5 lg:w-1/2 mb-20">
          <div class="text-3xl">Valgresultat</div>
          <div class="text-xl">
            <p class="mt-4">Studentene har nå valgt praksisapotek og dere er dessverre ett av de apotekene som ikke fikk student i denne omgangen.</p>
            <p class="mt-4">Vi takker for positiv respons og håper apoteket vil være praksisapotek igjen ved neste anledning!</p>
            <p class="mt-4">PS: Dersom det blir behov for flere praksisplasser på grunn av endringer etc., kan det være noen av dere hører fra oss.</p>
            <p class="mt-8">
              Vennlig hilsen
              <span class="block italic">Apotekforeningens praksispool</span>
            </p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
export default {
  name: 'ap-results',
  data () {
    return {
      isReady: false,
      electionPeriod: null,
      headers: [
        { text: 'Student', align: 'left', value: 'name' },
        { text: 'Fra læringssted', align: 'left', value: 'university' },
        { text: 'Grad', align: 'left', value: 'grade' },
        { text: 'Periode', align: 'left', value: 'period' }
      ],
      results: []
    }
  },
  computed: {
    items () {
      return _.map(this.results, r => {
        return {
          name: `${r.student.firstName} ${r.student.lastName}`,
          university: r.university.name,
          study: r.practicePeriod.studyDisplay,
          period: `${r.practicePeriod.from} - ${r.practicePeriod.to}`
        }
      })
    }
  },
  async created () {
    this.results = await api.ap.getResults()
    this.electionPeriod = await api.ap.getElectionPeriod()
    this.isReady = true
  }
}
</script>
